class OCTImageCover {
  constructor (el) {
    if (el.__imageCover) return

    this.el = el
    this.$_cover = this.cover.bind(this)

    this.el__imageCover = this

    window.addEventListener('resize', this.$_cover)

    // check load status
    !(this.el.complete || this.el.readyState === 'complete') ? this.el.addEventListener('load', this.$_cover) : this.cover()

    // case of video
    if (this.el.tagName === 'VIDEO')
      this.el.readyState === 0 ? this.el.addEventListener('loadedmetadata', this.$_cover) : this.cover()
  }

  cover () {
    const p = this.el.parentNode

    // has no parent or invisible case
    if (!p || !p.clientHeight) return;

    let w = p.clientWidth, h = p.clientHeight
    let width = this.el.naturalWidth || this.el.videoWidth, height = this.el.naturalHeight || this.el.videoHeight

    if (width/height > w/h) {
      this.el.style.width = 'auto'
      this.el.style.height = h + 'px'
    } else if (width/height <= w/h) {
      this.el.style.width = w + 'px'
      this.el.style.height = 'auto'
    }
  }
}

export default OCTImageCover
